var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"van-nav-tb"},[_c('van-nav-bar',{attrs:{"title":"标题","left-text":"","left-arrow":""},on:{"click-left":function($event){return _vm.$router.go(-1)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }